import fc from '@/firebaseConfig'
// import getDocTypeCharacter from "@/libs/expressLibrary/getDocTypeCharacter";
// import firebase from 'firebase/app'
// import jsonTx from "@/libs/expressLibrary/jsonTx";
// import jsonCr from "@/libs/expressLibrary/jsonCr";
// import jsonDr from "@/libs/expressLibrary/jsonDr";
// import jsonRe from "@/libs/expressLibrary/jsonRe";
// import jsonRt from "@/libs/expressLibrary/jsonRt";
// import jsonAb from "@/libs/expressLibrary/jsonAb";

export default async function mockDataDemo(companyId) {
  fc.db.collection('/Companies/9HF2imZ4yPN4eGis3sKI/Docs').get().then((snap) => {
    let batch = fc.db.batch()
    snap.forEach((doc) => {
      let newDoc = fc.db.collection(`/Companies/${companyId}/Docs/`).doc(doc.id)
      batch.set(newDoc, doc.data(), { merge: true })
    })
    batch.commit().then(function () {
      console.log('success batch upload')
    }).catch((error) => console.log('catch', error))
  })

  // let upsertStackList = []
  // upsertStackList.push(...await jsonTx.upsert())
  // upsertStackList.push(...await jsonCr.upsert())
  // upsertStackList.push(...await jsonDr.upsert())
  // upsertStackList.push(...await jsonRe.upsert())
  // upsertStackList.push(...await jsonRt.upsert())
  // upsertStackList.push(...await jsonAb.upsert())

  // let batch = fc.db.batch()
  // upsertStackList.forEach((json) => {
  // let docId = json['ED.ID'];
  // json['@TimeCreated'] = firebase.firestore.FieldValue.serverTimestamp();
  // json['@TimeUpdated'] = firebase.firestore.FieldValue.serverTimestamp();
  // json['ED.CreationDateTime.Timestamp'] = firebase.firestore.Timestamp.fromDate(new Date(json['ED.CreationDateTime.Timestamp']));
  // json['ED.IssueDateTime.Timestamp'] = firebase.firestore.Timestamp.fromDate(new Date(json['ED.IssueDateTime.Timestamp']));

  // if (json['@Payments']) {
  //   for (var k = 0; i < json['@Payments'].length; k++) {
  //     if (json["@Payments"][k]['dueDate.Timestamp']) {
  //       json["@Payments"][k]['dueDate.Timestamp'] = firebase.firestore.Timestamp.fromDate(new Date(json["@Payments"][k]['dueDate.Timestamp']));
  //     }
  //   }
  // }

  // if (json['SCTT.AHTS.STPT']) {
  //   for (var i = 0; i < json["SCTT.AHTS.STPT"].length; i++) {
  //     if (json["SCTT.AHTS.STPT"][i]['DueDateDateTime.Timestamp']) {
  //       json["SCTT.AHTS.STPT"][i]['DueDateDateTime.Timestamp'] = firebase.firestore.Timestamp.fromDate(new Date(json["SCTT.AHTS.STPT"][i]['DueDateDateTime.Timestamp']));
  //     }
  //   }
  // }

  // if (json["SCTT.AHTA.ARD"]) {
  //   for (var j = 0; j < json["SCTT.AHTA.ARD"].length; j++) {
  //     if (json["SCTT.AHTA.ARD"][j]['IssueDateTime.Timestamp']) {
  //       json["SCTT.AHTA.ARD"][j]['IssueDateTime.Timestamp'] = firebase.firestore.Timestamp.fromDate(new Date(json["SCTT.AHTA.ARD"][j]['IssueDateTime.Timestamp']));
  //     }
  //   }
  // }
  // docId = docId.toString().replace(/\//g, '-').replace('.', '-')
  // docId = docId + "_" + getDocTypeCharacter(json['@DocType'])




  //   let doc = fc.db.collection(`/Companies/${companyId}/Docs/`).doc(docId)
  //   batch.set(doc, json, { merge: true })
  // })

  // batch.commit().then(function () {
  //   console.log('success batch upload')
  // }).catch((error) => console.log('catch', error))
}
